import React, { useEffect, useState } from "react";

const Skills = () => {
  const [skillapi, setskillapi] = useState([]);
  useEffect(() => {
    fetch("https://rahul-server.vercel.app/skill")
      .then((res) => res.json())
      .then((data) => setskillapi(data));
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
      {skillapi.map((d) => (
        <>
          <div
            data-aos="fade-up"
            data-aos-duration="3000"
            key={d._id}
            className="w-full  border-blue-400 border-2"
          >
            <div className="flex justify-between text-2xl px-10">
              <h1>{d.name}</h1>
              <h1>{d.progress}%</h1>
            </div>
            <div className="px-3 py-2">
              <progress
                className="progress progress-success w-full h-5 border"
                value={d.progress}
                max="100"
              ></progress>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default Skills;
